import { R3VisualComponentBase } from "./R3VisualComponenteBase.classes";
import { ref, isRef } from "vue";
import type { Ref } from "vue";

export class R3FieldSetClass extends R3VisualComponentBase {

	private _title: Ref<string> = ref<string>("");

	/**
	 * Pode enviar o título ao construtor
	 * @param title
	 */
	constructor(title?: string) {
		super();
		if (title) {
			this._title.value = title;
			// if (isRef(this._title)) {
			// 	this._title.value = title;
			// } else {
			// 	this._title = title;
			// }
		}

	}
	public get title() {
		return this._title.value;
		// return isRef(this._title) ? this._title.value : this._title;
	}

	public set title(value: string) {
		this._title.value = value;
		// if (isRef(this._title)) {
		// 	this._title.value = value;
		// } else {
		// 	this._title = value;
		// }

	}

}